
















import {Component, Prop, Vue} from "vue-property-decorator";
@Component
export default class Decimal extends Vue {
    @Prop({required:true}) label!:string;
    @Prop({}) icon!:string;
    @Prop({}) md!:number;
    @Prop({}) value!:number;
    @Prop({default:true}) required!:boolean;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: false }) readonly!: boolean;
    
    get formattedValue(): string {
        return this.value !== undefined && this.value !== null ? this.value.toString() : '';
    }
    
    updateValue(value: string) {
        // Boş değer kontrolü
        if (value === '' || value === null || value === undefined) {
            this.$emit('input', null);
            return;
        }
        
        // Sayıya çevirme
        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
            this.$emit('input', numValue);
        }
    }
    
    get getIcon():any{
        if(this.icon){
            return false;
        }
        return this.icon;
    }
}
